// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

// ** Init login request
export const doLogin = data => {
  return dispatch => {
    dispatch({
      type: 'LOGIN_REQUEST',
      data
    })
  }
}

// ** Init login request
export const loginSucces = () => {
  return dispatch => {
    dispatch({
      type: 'LOGIN_REQUEST_SUCESS'
    })
  }
}

// ** Init login request
export const loginFail = errors => {
  return dispatch => {
    dispatch({
      type: 'LOGIN_REQUEST_FAILED',
      errors
    })
  }
}

// ** Handle User Login
export const handleLogin = data => {
  return dispatch => {
    dispatch({
      type: 'LOGIN',
      data,
      accessToken: data['token']
    })
  }
}

// ** Init User Logout Request
export const doLogout = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_REQUEST' })
  }
}

// ** Handle User Logout Success
export const handleLogout = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_SUCCESS', accessToken: null })
  }
}

// ** Handle User Logout Fail Event
export const handleLogoutFail = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_FAIL' })
  }
}

// ** Init User Logout From All Devices Request
export const doAllLogout = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_ALL_REQUEST' })
  }
}

// ** Handle User Logout From All Devices Success
export const handleAllLogout = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_ALL_REQUEST_SUCCESS', accessToken: null })
  }
}

// ** Handle User Logout From All Devices Fail Event
export const handleAllLogoutFail = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT_ALL_REQUEST_FAIL' })
  }
}

// ** Init Password Change Request
export const changePassword = (data) => {
  return dispatch => {
    dispatch({ type: 'PASSWORD_UPDATE', data })
  }
}

// ** Handle Password Change Success
export const changePasswordSuccess = () => {
  return dispatch => {
    dispatch({ type: 'PASSWORD_UPDATE_SUCCESS' })
  }
}

// ** Handle Password Change Fail
export const changePasswordFail = (errors) => {
  return dispatch => {
    dispatch({ type: 'PASSWORD_UPDATE_FAILED', errors })
  }
}


// ** Init Profile Update Request
export const updateProfile = (id, data) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_PROFILE', id, data })
  }
}

// ** Handle Profile Update Success
export const updateProfileSuccess = (data) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_PROFILE_SUCCESS', data })
  }
}

// ** Handle Profile Update Fail
export const updateProfileFail = (errors) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_PROFILE_FAILED', errors })
  }
}

// ** Init Forget Password Request
export const forgetPassword = (data, callback) => {
  return dispatch => {
    dispatch({ type: 'FORGET_PASSWORD', data, callback})
  }
}

// ** Handle Forget Password Success
export const forgetPasswordSuccess = () => {
  return dispatch => {
    dispatch({ type: 'FORGET_PASSWORD_SUCCESS' })
  }
}

// ** Handle Forget Password Fail
export const forgetPasswordFail = (errors) => {
  return dispatch => {
    dispatch({ type: 'FORGET_PASSWORD_FAILED', errors })
  }
}

// ** Init RESET Password Request
export const resetPassword = (data, callback) => {
  return dispatch => {
    dispatch({ type: 'RESET_PASSWORD', data, callback })
  }
}

// ** Handle RESET Password Success
export const resetPasswordSuccess = () => {
  return dispatch => {
    dispatch({ type: 'RESET_PASSWORD_SUCCESS' })
  }
}

// ** Handle RESET Password Fail
export const resetPasswordFail = (errors) => {
  return dispatch => {
    dispatch({ type: 'RESET_PASSWORD_FAILED', errors })
  }
}


// ** Init Profile Update Request
export const updateSmartContractData = (id, data) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_SMART_CONTRACT', id, data })
  }
}

// ** Handle Profile Update Success
export const updateSmartContractDataSuccess = (data) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_SMART_CONTRACTE_SUCCESS', data })
  }
}

// ** Handle Password Change Fail
export const updateSmartContractFail = (errors) => {
  return dispatch => {
    dispatch({ type: 'UPDATE_SMART_CONTRACT_FAILED', errors })
  }
}

